'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  footerSelector: _propTypes2.default.string,
  stickyClass: _propTypes2.default.string
};

var defaultProps = {
  footerSelector: '#footer',
  stickyClass: 'stick-to-viewport'
};

var StickToFooter = function (_Component) {
  _inherits(StickToFooter, _Component);

  _createClass(StickToFooter, null, [{
    key: 'isServerRendered',
    value: function isServerRendered() {
      return typeof window === 'undefined';
    }
  }]);

  function StickToFooter() {
    _classCallCheck(this, StickToFooter);

    var _this = _possibleConstructorReturn(this, (StickToFooter.__proto__ || Object.getPrototypeOf(StickToFooter)).call(this));

    if (!StickToFooter.isServerRendered()) {
      _this.state = {
        isFooterInView: false
      };
      _this.footerEl = null;
      _this.el = null;
      _this.footerInView = _this.footerInView.bind(_this);
    }
    return _this;
  }

  _createClass(StickToFooter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var footerSelector = this.props.footerSelector;

      this.footerEl = document.querySelector(footerSelector);
      window.addEventListener('scroll', this.footerInView);
      window.addEventListener('resize', this.footerInView);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.footerInView);
      window.removeEventListener('resize', this.footerInView);
    }
  }, {
    key: 'footerInView',
    value: function footerInView() {
      if (!this.footerEl) {
        console.warn('Missing footer element.'); // eslint-disable-line
        return;
      }

      var winHeight = window.innerHeight;
      var childBounds = this.el.getBoundingClientRect();
      var footerOffsetTop = this.footerEl.getBoundingClientRect().top + this.el.offsetHeight;
      var footerInView = footerOffsetTop < winHeight;
      var childInView = childBounds.top < winHeight;
      var elBottomInView = childBounds.bottom < winHeight;

      if (footerInView && childInView) {
        this.setState({
          isFooterInView: true
        });
      }

      if (!footerInView && !elBottomInView) {
        this.setState({
          isFooterInView: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          stickyClass = _props.stickyClass,
          children = _props.children,
          className = _props.className;

      var classes = [className];

      if (!StickToFooter.isServerRendered() && !this.state.isFooterInView) {
        classes.push(stickyClass);
      }

      return _react2.default.createElement(
        'div',
        { className: classes.join(' ').trim(), ref: function ref(el) {
            _this2.el = el;
          } },
        children
      );
    }
  }]);

  return StickToFooter;
}(_react.Component);

StickToFooter.propTypes = propTypes;

StickToFooter.defaultProps = defaultProps;

exports.default = StickToFooter;


// WEBPACK FOOTER //
// ../~/@jg/components/es/StickToFooter/StickToFooter.js